import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const Footer = styled.footer`
  font-family: 'Pretendard Variable', Pretendard, -apple-system,
    BlinkMacSystemFont, 'Apple SD Gothic Neo', Roboto, 'Noto Sans KR',
    'Segoe UI', 'Malgun Gothic', 'Apple Color Emoji', 'Segoe UI Emoji',
    'Segoe UI Symbol', sans-serif;
  position: relative;
  z-index: 5;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);

  .inner-footer {
    padding: 24px 20px 114px 20px;
    margin-top: 64px;
    background-color: #f9f9f9;
    border-top: 1px solid #eee;
    word-break: keep-all;
  }

  .nav-util {
    ${mixin.flex({ wrap: 'wrap', justify: 'flex-start' })};
    column-gap: 10px;

    &::after {
      content: '';
      flex-basis: 100%;
      height: 0;
      order: 1;
    }

    li:nth-last-child(2),
    li:last-child {
      order: 2;
      margin-top: 10px;
    }

    button,
    a {
      display: block;
      color: #555;
      font-weight: 500;
      font-size: 14px;
      line-height: 120%;
    }
  }

  .nav-terms {
    margin-top: 18px;
    gap: 10px;
    ${mixin.flex({ justify: 'flex-start', wrap: 'wrap' })};
    width: 250px;

    a {
      color: #555;
      font-weight: 500;
      font-size: 14px;
      line-height: 120%;
    }

    strong {
      color: #000;
      font-weight: 600;
    }
  }

  .info {
    margin-top: 26px;

    .inf-sum {
      ${mixin.flex({ justify: 'flex-start' })};
      font-size: 15px;
      color: #000;
      font-weight: 500;
      position: relative;

      svg {
        margin-left: 5px;
      }
    }

    &[open] {
      .inf-sum svg {
        transform: rotate(180deg);
      }
    }

    .inf-list {
      margin-top: 10px;
      font-size: 12px;
      color: #777;
      line-height: 130%;

      li {
        margin-top: 2px;

        &:first-child {
          margin-top: 0;
        }
      }

      a {
        color: #000;
        text-decoration: underline;

        &.tel {
          color: #777;
          text-decoration: none;
        }
      }
    }
  }

  .copyright {
    color: #999;
    margin-top: 8px;
    font-size: 12px;
    line-height: 130%;
  }

  .desc {
    font-size: 11px;
    line-height: 135%;
    margin-top: 18px;
    color: #999;
    word-break: keep-all;
  }

  .nav-social {
    margin-top: 18px;
  }

  @media ${({ theme }) => theme.media.smMax} {
    .inner-footer {
      padding: ${mixin.pxToVw('24 20 114 20')};
      margin-top: ${mixin.pxToVw('64')};
    }

    .nav-util {
      column-gap: ${mixin.pxToVw('10')};

      li:nth-last-child(2),
      li:last-child {
        margin-top: ${mixin.pxToVw('10')};
      }

      button,
      a {
        font-size: ${mixin.pxToVw('14')};
      }
    }

    .nav-terms {
      margin-top: ${mixin.pxToVw('18')};
      gap: ${mixin.pxToVw('10')};
      width: ${mixin.pxToVw('250')};

      a {
        font-size: ${mixin.pxToVw('14')};
      }
    }

    .info {
      margin-top: ${mixin.pxToVw('26')};

      .inf-sum {
        font-size: ${mixin.pxToVw('15')};

        svg {
          margin-left: ${mixin.pxToVw('5')};
        }
      }

      .inf-list {
        margin-top: ${mixin.pxToVw('10')};
        font-size: ${mixin.pxToVw('12')};

        li {
          margin-top: ${mixin.pxToVw('2')};
        }
      }
    }

    .copyright {
      margin-top: ${mixin.pxToVw('8')};
      font-size: ${mixin.pxToVw('12')};
    }

    .desc {
      font-size: ${mixin.pxToVw('11')};
      margin-top: ${mixin.pxToVw('18')};
    }

    .nav-social {
      margin-top: ${mixin.pxToVw('18')};
    }
  }
`;
